<div class="atn-scenario-variables-tab">
  <atn-variables />
</div>
